import PlanCard from "./PlanCard";
import ActionInformationText from "./ActionInformationText";
import SubscriptionPlanButton from "./SubscriptionPlanButton";
import { useHistory } from "react-router";
import AutoPurchasableProductLicense from "interfaces/response/AutoPurchasableProductLicense";
import { convertToInternationalNumberSystem } from "shared/utility/NumberUtility";

interface Props {
  defaultFreeLicense: AutoPurchasableProductLicense | undefined;
}

export default function FreePlanCard(props: Props) {
  const history = useHistory();
  const { defaultFreeLicense } = props;
  
  const actionInformationText = `${convertToInternationalNumberSystem(defaultFreeLicense?.numberOfAllowedActions ? defaultFreeLicense.numberOfAllowedActions : 0)} actions / ${defaultFreeLicense?.actionValidationDurationUnitText?.toLowerCase()}`;

  const handleOnClick = () => {
    history.push("/sign-up");
  };

  const ActionButton = () => {
    return (
      <SubscriptionPlanButton text="GET STARTED" onClick={handleOnClick} />
    );
  };

  const ActionInformation = () => {
    return <ActionInformationText text={actionInformationText} />;
  };

  return (
    <>
      <PlanCard
        name="Free"
        price="0"
        description="Give timePhasing a try,
no strings attached."
        tag="free forever."
        actionInformation={<ActionInformation />}
        actionButton={<ActionButton />}
      />
    </>
  );
}
